
<template>
  <el-form
    class="applybox"
    :model="applyGuildForm"
    :rules="rules"
    ref="applyGuildForm"
    label-width="120px"
    size="small"
  >
    <el-form-item :label="$t('m.agency_name')" prop="guildName">
      <el-input
        v-model.trim="applyGuildForm.guildName"
        maxlength="20"
        :placeholder="$t('m.agency_name_input')"
      ></el-input>
      <p class="tip_txt">{{$t('m.agency_name_input_note')}}</p>
    </el-form-item>
    <el-form-item :label="$t('m.agency_logo')" prop="guildLogo" style="margin-bottom: 0">
      <el-upload
        class="avatar-uploader"
        :class="{ hideUploadBtn: guildLogoArr.length > 0 }"
        :action="uploadAction"
        list-type="picture-card"
        :multiple="false"
        :limit="1"
        :on-remove="removeLogoUpload"
        :on-success="onUploadLogo"
        :on-error="onUploadError"
        :file-list="guildLogoArr"
        :before-upload="beforeLogoUpload"
        accept=".jpg,.png,.jpeg"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <p class="tip_txt">{{$t('m.agency_logo_unpload_note')}}</p>
    </el-form-item>

    <el-form-item :label="$t('m.agency_contact_name')" prop="guildContacts">
      <el-input
        v-model.trim="applyGuildForm.guildContacts"
        maxlength="20"
        :placeholder="$t('m.user_contact_name')"
        @input="
            applyGuildForm.guildContacts = $notNum(
              applyGuildForm.guildContacts
            )
          "
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('m.agency_contact_phone')" prop="guildContactsPhone">
      <div class="fc-flex fc-flex-vcenter">
        <div class="seledArea" @click.stop="showCountryFun">
          <img class="flag_icon" :src="selCountry.logo" />
          <span class="countrynum">+{{ selCountry.countryNum }}</span>
          <img
            class="select_icon"
            :src="(showCountry && $store.state.isShowSelArea)? require('../../../assets/img/icon_up.png'): require('../../../assets/img/icon_down.png')"
          />
        </div>
        <el-input
          v-model.trim="applyGuildForm.guildContactsPhone"
          minlength="6"
          @input="
            applyGuildForm.guildContactsPhone = $num(
              applyGuildForm.guildContactsPhone
            )
          "
          :placeholder="$t('m.agency_contact_phone')"
        ></el-input>
        <div class="selarea_box" v-if="showCountry && $store.state.isShowSelArea">
          <sel-area @countryOption="countryOptionFun" />
        </div>
      </div>
    </el-form-item>
    <!-- 2022-9-16 验证码不要了 -->
    <!-- <el-form-item :label="$t('m.vericode')" prop="code">
      <div class="fc-flex">
        <div class="fc-flex1">
          <el-input
            v-model.trim="applyGuildForm.code"
            maxlength="6"
            @input="
              applyGuildForm.code = applyGuildForm.code.replace(/\D/g, '')
            "
            :placeholder="$t('m.vericode')"
          ></el-input>
        </div>
        <send-code
          class="fc-mar-l-min"
          styleType="button"
          :areaCode="selCountry.countryNum"
          :mobile="applyGuildForm.guildContactsPhone"
          :scene="2"
        ></send-code>
      </div>
    </el-form-item> -->

    <el-form-item :label="$t('m.agency_whatsapp')" prop="guildAdminWhatsApp">
      <el-input
        v-model.trim="applyGuildForm.guildAdminWhatsApp"
        :placeholder="$t('m.agency_whatsapp_contact')"
        maxlength="50"
      ></el-input>
    </el-form-item>
    <!--邮箱-->
    <el-form-item :label="$t('m.email')" prop="email">
      <el-input
        v-model.trim="applyGuildForm.email"
        :placeholder="$t('m.email')"
        maxlength="70"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('m.agency_use_lang')" prop="guildAdminUserLang">
      <el-select
        filterable
        v-model="applyGuildForm.guildAdminUserLang"
        multiple
        :placeholder="$t('m.select')"
      >
        <el-option
          v-for="item in guildAdminUserLangArr"
          :key="item.key"
          :label="item.name"
          :value="item.key"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('m.agency_head_ID')" prop="guildAdminId">
      <el-input
        v-model.trim="applyGuildForm.guildAdminId"
        maxlength="10"
        :disabled = "!!this.$store.state.userInfo.appUserId"
        @input="applyGuildForm.guildAdminId = applyGuildForm.guildAdminId.replace(/\D/g,'')"
        :placeholder="$t('m.agency_ID_input')"
      ></el-input>
      <span
        class="el-form-item__error"
        v-if="guildAdminNickname"
        style="margin: 0"
      >
        <!-- 用户昵称 -->
        {{$t('m.nickname')}} 【{{ guildAdminNickname }}】
        <br>
        <p v-if="signState === 1" style="color: red">
            {{$t('m.cant_commit')}}
        </p>
        <p v-if="signState === 2" style="color: red">
            {{$t('m.cant_commit_1')}}
        </p>
      </span>
      <i class="el-icon-loading el-form-item__error" v-if="getnameloading"></i>
    </el-form-item>
    <div class="phoneSex">
      <el-form-item :label="$t('m.reg_country')">
        <div>{{ phoneCountry }}</div>
      </el-form-item>
      <el-form-item :label="$t('m.app_phone')" label-width="126px">
        <div>{{mobile}}</div>
      </el-form-item>
      <el-form-item :label="$t('m.gender')">
        <div v-if="sex ===0 ">{{$t('m.female')}}</div>
        <div v-if="sex ===1 ">{{$t('m.male')}}</div>
      </el-form-item>
    </div>
    <el-form-item :label="$t('m.inhand_ID_photo')" prop="guildAdminCardJustPic">
      <div class="zhizhaopic">
        <div>
          <el-upload
            class="avatar-uploader"
            :class="{
              hideUploadBtn: guildAdminCardJustPicArr.length > 0,
            }"
            :action="uploadAction"
            list-type="picture-card"
            :multiple="false"
            :limit="1"
            :before-upload="beforePicUpload"
            :on-remove="removeBusinessPicUpload"
            :on-success="onUploadBusinessPic"
            :on-error="onUploadError"
            :file-list="guildAdminCardJustPicArr"
            accept=".jpg,.png,.jpeg"
          >
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </div>
        <div class="notebox">
          <img
            class="zhizhaopic"
            src="../../../assets/img/zhengjian.png"
            alt=""
          />
          <div class="note">
            <p>{{$t('m.upload_note_t')}}:</p>
            <p>1、{{$t('m.agency_self_inhand_ID')}};</p>
            <p>2、{{$t('m.photo_must_clearly')}}; </p>
          </div>
        </div>
      </div>
    </el-form-item>

    <el-form-item :label="$t('m.mian_form_country')" prop="anchorCountry">
      <el-select
        filterable
        v-model="applyGuildForm.anchorCountry"
        multiple
        :placeholder="$t('m.select')"
      >
        <el-option
          v-for="item in anchorCountryArr"
          :key="item.coding+item.id"
          :label="item.content"
          :value="item.coding"
        >
        </el-option>
      </el-select>
    </el-form-item>
    <el-form-item :label="$t('m.invite_code')" prop="inviteCode">
      <el-input
        v-model.trim="applyGuildForm.inviteCode"
        :disabled="linkInviteCode"
        oninput="value=value.replace(/\D/g,'')"
        :maxlength="6"
        :placeholder="$t('m.invite_code')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('m.host_num')" prop="anchorNum">
      <el-input
        v-model.trim="applyGuildForm.anchorNum"
        oninput="value=value.replace(/^(0+)|[^\d]+/g,'')"
        maxlength="9"
        :placeholder="$t('m.enter_host_num')"
      ></el-input>
    </el-form-item>
    <el-form-item :label="$t('m.platform')" prop="cooperationPlatform">
      <el-input
        type="textarea"
        v-model.trim="applyGuildForm.cooperationPlatform"
        :placeholder="$t('m.many_platforms')"
      ></el-input>
    </el-form-item>
    <div style="display: flex;line-height: 2.2;width: 100%;">
      <div style="width: 90%;">
        <el-form-item :label="$t('m.statement')" prop="monthFlow">
          <el-input
            v-model.trim="applyGuildForm.monthFlow"
            oninput="value=value.replace(/\D/g,'')"
            maxlength="9"
            :placeholder="$t('m.enter_income')"
          ></el-input>
        </el-form-item>
      </div>
      <div>{{$t('m.usd')}}</div>
    </div>
    <el-form-item style="text-align: right; margin-bottom: 20px">
      <el-button
        type="primary"
        @click="submitForm('applyGuildForm')"
        :loading="btnLoading"
        :disabled="signState === 1 || signState === 2"
        >{{$t('m.submit')}}</el-button
      >
    </el-form-item>
  </el-form>
</template>

<script>
import sendcode from "../../../components/sendcode";
import { getGuildAdminNickname,guildSave } from "../../../api/apply/index";
import { getCountryMsg,anchorCountryArrAjax } from "../../../api/common";
import { smscode, mobileValid, isSmscode, isEmailValid } from "../../../utils/coding-utils";
import { emptyApplyGuildForm } from "../../../utils/empty-model";
import { userLangArr,arrToString } from "../../../utils/common";
import SelArea from "../../../components/SelArea";
import {isEmailValidPattern} from "@/utils/coding-utils";
export default {
  name: "apply-form",
  components: {
    "send-code": sendcode,
    "sel-area": SelArea,
  },
  data() {
    const token = this.$store.state.userInfo.token;
    return {
      uploadAction:
        this.global_huanjing.uploadApi +
        "?token=" +token +
        "&flag=5" +
        "&temp=" +new Date().getTime(),
      btnLoading: false,
      applyGuildForm: emptyApplyGuildForm(),
      showCountry: false,
      selCountry: {},
      guildLogoArr:[],
      guildAdminCardJustPicArr:[],

      //使用语言
      guildAdminUserLangArr: userLangArr,
      selGuildAdminUserLangArr: [],

      // 来源国家 /选择来源国家
      anchorCountryArr:[],
      selAnchorCountryArr:[],

      LogoInfo: {
        hideUpload: false,
        fileList: [],
        guildLogo: "",
      },
      turnoverPicInfo: {
        hideUpload: false,
        fileList: [],
        turnoverPic: [],
      },

      guildAdminNickname: "",
      phoneCountry:null,
      sex: null,
      mobile: null,
      getnameloading: false,
      //  0： 不是公会主播  1：是公会主播 2：用户申请主播中
      signState: 0,
      rules: {
        guildName: [
          { required: true, message: this.$t('m.agency_name_input'), trigger: "blur" },
          { min: 1, max: 20, message: this.$t('m.over_word_limit'), trigger: "blur" },
        ],
        guildContacts: [
          { required: true, message: this.$t('m.no_data'), trigger: "blur" },
        ],
        email: [
          { required: true, message: this.$t('m.no_data'), trigger: "blur" },
          { pattern: isEmailValidPattern(), message: this.$t('m.email_check') },
        ],
        guildContactsPhone: [
          { required: true, message: this.$t('m.no_data'), trigger: "blur" },
          { pattern: mobileValid(), message: this.$t('m.email_check') },
        ],
        code: [
          { required: true, message: this.$t('m.input_vericode'), trigger: "blur" },
          { pattern: smscode(), message: this.$t('m.vericode_error') },
        ],
        guildAdminId: [
          { required: true, message: this.$t('m.no_data'), trigger: "blur" },
          { validator: this.validatorDuration, trigger: "blur" },
        ],
        guildAdminWhatsApp: [
          { required: true, message: this.$t('m.agency_whatsapp_contact'), trigger: "blur" },
        ],
        guildAdminUserLang: [
          { required: true, message: this.$t('m.no_data'), trigger: "blur" },
        ],
        anchorCountry: [
          { required: true, message: this.$t('m.no_data'), trigger: "blur" },
        ],
        guildAdminCardJustPic: [{ required: true, message: this.$t('m.no_data'), trigger: "change" }],
      },
      linkInviteCode: false,
    };
  },
  watch: {
    'applyGuildForm.guildAdminId':{
      handler(val){
        if(!val){
          this.guildAdminNickname=null;
          this.phoneCountry=null;
          this.sex = null;
          this.mobile = null;
        }
      }
    }
  },
  mounted() {
    console.log(this.$store.state.userInfo);
    // this.applyGuildForm.id = this.$store.state.userInfo.guildUserId;
    this.applyGuildForm.guildContactsPhone=this.$store.state.userInfo.mobile;
    if(this.$store.state.userInfo.appUserId) {
      this.applyGuildForm.guildAdminId = this.$store.state.userInfo.appUserId;
    }
    this.selCountry={
      logo:'',
      countryNum:this.$store.state.userInfo.areaCode,
    }
    this.anchorCountryArrFun();
    this.getCountryMsgFun();
    this.$refs.applyGuildForm.validateField('guildAdminId', (valid) => { })
    if (this.$route.query.inviteCode) {
      this.applyGuildForm.inviteCode = this.$route.query.inviteCode;
      this.linkInviteCode = true;
    }
  },
  methods: {

    // 显示区号？
    showCountryFun(){
      if(this.showCountry && this.$store.state.isShowSelArea){
        this.showCountry = false;
        this.$store.state.isShowSelArea = false;
      }else{
        this.$store.state.isShowSelArea=true;
        this.showCountry = true;
      }
    },
    //获取默认区号
    getCountryMsgFun(){
      if(this.selCountry.countryNum) return false;
      getCountryMsg().then(({data}) =>{
        this.selCountry=data.result;
      })
    },
    // 获取来源国家
    anchorCountryArrFun(){
      if(this.$store.state.countryArr){
        this.anchorCountryArr=this.$store.state.countryArr;
      }else{
        anchorCountryArrAjax()
          .then(({ data }) => {
            this.anchorCountryArr=data.data;
          })
          .catch((error) => {

          });
      }

    },
    // 选择区号
    countryOptionFun(val) {
      this.selCountry = val;
      this.showCountry = false;
    },
    //校验公会长信息
    async validatorDuration(rules, value, callback) {
      this.getnameloading = true;
      if (value) {
        let detail = await this.getGuildAdminNickname();
        this.getnameloading = false;
        this.guildAdminNickname = null;
        if (!detail) {
          callback(new Error(this.$t('m.user_not_exist')));
        } else if (detail.statues == 1) {
          this.guildAdminNickname = detail.nickName;
          this.phoneCountry=detail.phoneCountry;
          this.mobile=detail.mobile;
          this.sex=detail.sex;
          this.signState = detail.flag;
          console.log(123456);
          callback();
        }else if (detail.statues == 2) {
          // 用户被临时冻结
          callback(new Error(this.$t('m.user_frozen')));
        } else if (detail.statues == 3) {
          callback(new Error(this.$t('m.user_frozen')));
        }else if (detail.statues == 4) {
          callback(new Error(this.$t('m.user_has_delete')));
        }else {
          callback(new Error(this.$t('m.user_not_exist')));
        }
      }else{

      }
    },
    //获取公会长昵称
    getGuildAdminNickname() {
      if (!this.applyGuildForm.guildAdminId) {
        this.guildAdminNickname = "";
        return false;
      }
      return new Promise((resolve, reject) => {
        getGuildAdminNickname(this.applyGuildForm.guildAdminId)
          .then(({ data }) => {
            resolve(data.data);
          })
          .catch((error) => {
            this.btnLoading = false;
            reject(this.$t('m.network_busy'));
          });
      });
    },

    //上传Logo
    onUploadError(error, file, fileList) {
      this.$message({
        type: "error",
        message: this.$t('m.img_upload_fail'),
      });
    },
    //移除文件
    removeLogoUpload(file, fileList) {
      this.guildLogoArr = [];
      this.applyGuildForm.guildLogo = null;
    },
    onUploadLogo(response, file, fileList) {
      if (response.code && response.code !== 1) {
        // 此时虽然http的status=200, 但实际上结果为上传失败!!!
        this.$message({
          type: "error",
          message: this.$t('m.img_upload_fail')+":" + response.msg,
        });
        return;
      }
      console.log(response.result);
      this.guildLogoArr = [].concat({ url: response.result });
      this.applyGuildForm.guildLogo = response.result;
    },
    beforeLogoUpload(file) {
      return this.uploadLimit(file);
    },
    //上传end

    //上传手持身份证
    removeBusinessPicUpload(file, fileList) {
      this.guildAdminCardJustPicArr = [];
      this.applyGuildForm.guildAdminCardJustPic = "";
    },
    onUploadBusinessPic(response, file, fileList) {
      if (response.code && response.code !== 1) {
        this.$message({
          type: "error",
          message: this.$t('m.img_upload_fail')+":" + response.msg,
        });
        return;
      }
      this.guildAdminCardJustPicArr = [].concat({
        url: response.result,
      });
      this.applyGuildForm.guildAdminCardJustPic = response.result;
    },
    beforePicUpload(file) {
      return this.uploadLimit(file);
    },
    //上传手持身份证end

    uploadLimit(file, hasPdf) {
      const isLt5M = file.size / 1024 / 1024 < 5;
      let isJPG = false;
      if (hasPdf) {
        if (
          file.type == "image/jpeg" ||
          file.type == "image/jpg" ||
          file.type == "image/png" ||
          file.type == "application/pdf"
        ) {
          isJPG = true;
        }
      } else {
        if (
          file.type == "image/jpeg" ||
          file.type == "image/jpg" ||
          file.type == "image/png"
        ) {
          isJPG = true;
        }
      }
      if (!isJPG) {
        this.$message.error(this.$t('m.upload_file_format_incorrect'));
        return isJPG;
      }
      if (!isLt5M) {
        this.$message.error(this.$t('m.file_is_too_large'));
        return isLt5M;
      }
      return isJPG && isLt5M;
    },
    beforeTurnoverPicUpload(file) {
      return this.uploadLimit(file, true);
    },
    //提交审核
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.applyGuildForm.cooperationPlatform) {
            let strfrom = this.applyGuildForm.cooperationPlatform.split(',').length;
            if(/，|^,|,$/.test(this.applyGuildForm.cooperationPlatform)){
             this.$alert(this.$t('m.check_commas'), this.$t('m.tip'), {
               confirmButtonText: this.$t('m.i_got_it'),
             });
             return;
            }
            if(strfrom>20) {
              this.$alert(this.$t('m.limit_platform'), this.$t('m.tip'), {
                confirmButtonText: this.$t('m.i_got_it'),
              });
              return;
            }
          };
          console.log(this.applyGuildForm);
          let sendJson=JSON.parse(JSON.stringify(this.applyGuildForm));

          this.btnLoading = true;
          sendJson.guildAdminUserLang=arrToString(this.applyGuildForm.guildAdminUserLang);
          sendJson.anchorCountry=arrToString(this.applyGuildForm.anchorCountry);
          sendJson.guildContactsAreaCode=this.selCountry.countryNum;
          console.log(sendJson);
          // return;
          guildSave(sendJson)
            .then(({ data }) => {
              this.btnLoading = false;
              this.$emit("updateStepActive", 1);
              console.log(123);
            })
            .catch((error) => {
              this.btnLoading = false;
            });
        } else {
          console.log("error submit!!");
          this.btnLoading = false;
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
};
</script>
<style  lang="less">
.applybox {
  .el-upload-list__item-thumbnail {
    position: relative;
    overflow: hidden;
    background-image: url("../../../assets/img/file_suo.png");
    background-size: cover;
    &::before {
      content: "";
      width: 100%;
      height: 100%;
      position: absolute;
      left: 0;
      top: 0;
      background-image: url("../../../assets/img/file_suo.png");
      background-size: cover;
    }
  }
  .el-form-item__error{
    position: relative;
  }
}
</style>
<style lang="scss" scoped>
.tip_txt {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
  line-height: 1.2;
}

.zhizhaopic {
  display: flex;
  align-content: center;
  color: #999;
  .notebox {
    flex: 1;
    padding: 10px;
    background-color: #f7f7f7;
    display: flex;
    align-items: center;
    margin-left: 10px;
    .zhizhaopic {
      width: 60px;
      margin-right: 10px;
    }
    .note {
      flex: 1;
      font-size: 12px;
      line-height: 1.5;
    }
  }
}
@media only screen and (max-width: 767px) {
  .zhizhaopic {
    flex-direction: column;
    .notebox {
      margin-top: 10px;
      margin-left: -110px;
    }
  }
  .phoneSex{
    flex-wrap: wrap;
  }
}
.applyform{
      .el-form-item{
        display: flex;
        align-items: center;
        &__label{
          line-height: 1.2;
          padding-top: 7px;
        }
        &__content{
          margin-left: 0 !important;
          flex: 1;
        }
      }
      .el-select{
        width: 100%;
      }
      .el-form-item__label{
        padding-top: 0;
      }
  }
  .ar{
    .fc-mar-l-min{
      margin-left: 0;
      margin-right: 10px;
    }
    .zhizhaopic .notebox{
      margin-left: 0 !important;
      margin-right: 10px;
    }
  }
  .phoneSex{
    display: flex;
    justify-content: space-between;
  }
</style>



// WEBPACK FOOTER //
// src/pages/apply/components/applyform.vue